import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={24}
    height={24}
    viewBox="0 0 6.35 6.35"
  >
    <defs>
      <clipPath id="a">
        <path fillRule="evenodd" d="M642 317h57v55h-57z" clipRule="evenodd" />
      </clipPath>
      <clipPath id="b">
        <path fillRule="evenodd" d="M646 233h42v46h-42z" clipRule="evenodd" />
      </clipPath>
      <clipPath id="c">
        <path fillRule="evenodd" d="M637 138h60v62h-60z" clipRule="evenodd" />
      </clipPath>
    </defs>
    <g
      style={{
        display: "inline",
      }}
    >
      <g
        style={{
          overflow: "hidden",
        }}
      >
        <g
          stroke="currentColor"
          strokeMiterlimit={8}
          clipPath="url(#c)"
          transform="matrix(.10269 0 0 .10269 -65.357 -14.213)"
        >
          <path
            fill="none"
            strokeWidth={5}
            d="M640.5 169.5c0-15.464 12.088-28 27-28s27 12.536 27 28-12.088 28-27 28-27-12.536-27-28z"
          />
          <path
          fill="currentColor"
            fillRule="evenodd"
            d="M661.5 169.5a6 6 0 1 1 12 0 6 6 0 0 1-12 0z"
          />
          <path
            fill="none"
            strokeWidth={4}
            d="M667 156c6.627 0 12 5.149 12 11.5"
          />
          <path
            fill="none"
            strokeWidth={4}
            d="M656 168.5c0-6.904 5.149-12.5 11.5-12.5M656 180.459l7.12-7.46"
          />
        </g>
        <path
          d="M29.174 61.92c-9.255-.402-17.842-5.38-23.064-13.37-1.496-2.291-2.505-4.354-3.378-6.91C.047 33.78.579 25.192 4.212 17.773A30.275 30.275 0 0 1 14.846 5.71a28.69 28.69 0 0 1 20.737-4.215c7.544 1.34 14.491 5.888 18.946 12.403 2.878 4.208 4.594 8.827 5.248 14.121.189 1.534.189 5.398 0 6.93-.473 3.822-1.358 6.885-2.93 10.135-3.19 6.597-8.598 11.797-15.19 14.607-2.96 1.262-6.481 2.08-9.454 2.2-.538.02-1.164.048-1.39.06-.225.012-.962-.002-1.639-.031zm4.735-5.124c4.043-.625 7.78-2.188 10.949-4.58 2.015-1.522 4.04-3.62 5.478-5.675 2.503-3.58 3.989-7.56 4.563-12.225.145-1.174.12-4.696-.042-5.961-.772-6.033-3.267-11.182-7.42-15.314-1.93-1.92-3.939-3.38-6.245-4.535-8.043-4.031-17.664-3.203-24.864 2.14-2.173 1.613-4.29 3.804-5.804 6.009-2.497 3.636-4.046 7.973-4.454 12.465-.131 1.45-.054 4.754.141 6.053 1.015 6.741 4.191 12.403 9.274 16.53 3.422 2.78 7.887 4.676 12.124 5.15.39.044.809.094.932.11.123.017 1.162.02 2.31.007 1.628-.018 2.3-.056 3.058-.174z"
          style={{
            fill: "currentColor",
            strokeWidth: 0.0745192,
          }}
          transform="matrix(.10269 0 0 .10269 .056 -.042)"
        />
        <path
          d="M17.028 30.188c0-1.183.339-3.107.788-4.473 1.035-3.144 2.983-5.739 5.654-7.532 2.261-1.518 5.252-2.326 7.733-2.09 4.396.42 8.17 2.625 10.53 6.151 1.28 1.912 2.069 4.217 2.176 6.353l.042.838h-1.948c-1.806 0-1.949-.01-1.95-.13-.002-.436-.179-1.574-.34-2.18-1.04-3.929-4.707-6.849-8.948-7.125-2.394-.157-4.956.916-6.803 2.848-1.761 1.842-2.81 4.273-2.962 6.867l-.045.763h-3.927z"
          style={{
            fill: "currentColor",
            strokeWidth: 0.0745192,
          }}
          transform="matrix(.10269 0 0 .10269 .056 -.042)"
        />
        <path
          d="M20.008 43.352 18.61 42.02l-.988-.944 3.432-3.596c2.494-2.612 3.42-3.628 3.386-3.715-.15-.38-.343-1.324-.383-1.877-.192-2.694 1.512-5.365 4.074-6.386.859-.342 1.327-.423 2.422-.418.912.005 1.127.03 1.714.208 1.945.588 3.481 1.976 4.216 3.81.321.803.448 1.492.447 2.432-.001 1.811-.668 3.346-2.008 4.627a6.377 6.377 0 0 1-2.469 1.483c-.61.2-.848.237-1.714.267-1.228.043-1.965-.106-3.042-.616a18.183 18.183 0 0 0-.725-.333c-.012 0-1.47 1.517-3.24 3.372-1.77 1.854-3.24 3.38-3.266 3.388-.026.01-.232-.157-.458-.37z"
          style={{
            fill: "currentColor",
            strokeWidth: 0.0745192,
          }}
          transform="matrix(.10269 0 0 .10269 .056 -.042)"
        />
      </g>
    </g>
  </svg>
);




